import { Box, Text } from '@chakra-ui/core';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { companyForCity, legalHref } from '../config/legalDocs';

/**
 * A `/:city/privacy` útvonal a jogi dokumentum publikus oldalára irányít.
 *
 * Korábban ez a képernyő a FORNO adatkezelési tájékoztatójának egy rövidített,
 * JSX-be égetett másolatát tartalmazta. Sehonnan nem volt rá link, publikusan
 * viszont elérhető volt — két, egymásnak ellentmondó adatvédelmi tájékoztató
 * élesben pedig jogi kockázat. A szöveg egyetlen forrása mostantól a
 * `content/legal/*.md`, amiből a build statikus HTML oldalt generál.
 *
 * A cím a városhoz tartozó céghez igazodik (Szolnok = FORNO, Kecskemét =
 * Pastaline); amelyik dokumentumnak még nincs HTML változata, ott a `legalHref`
 * a régi PDF-re esik vissza.
 */
const PrivacyScreen = (): JSX.Element => {
  const { city } = useParams<{ city: string }>();
  const target = legalHref(`adatkezeles-${companyForCity(city)}`);

  useEffect(() => {
    // replace(): a vissza gomb ne dobjon vissza ide, mert innen azonnal
    // újraindulna az átirányítás.
    window.location.replace(target);
  }, [target]);

  return (
    <Box as='main' mt={4} color='white' textAlign='center'>
      <Text>
        Átirányítás az adatkezelési tájékoztatóra… Ha nem történik meg magától,{' '}
        <a href={target}>kattints ide</a>.
      </Text>
    </Box>
  );
};

export default PrivacyScreen;
